import type { Faq } from '../types/content'

export const faqs: Faq[] = [
  {
    q: 'How do I receive the material?',
    a: 'You receive immediate digital access after purchasing.',
  },
  {
    q: 'What level of coach is this for?',
    a: 'The system is designed to support coaches working from beginner development through advanced athletes.',
  },
  {
    q: 'Does it work worldwide?',
    a: 'Yes. The material uses broadly applicable Track & Field terminology and metric measurements without depending on one federation.',
  },
  {
    q: 'Is the material editable?',
    a: 'The resources are delivered in PDF format and are ready to use.',
  },
  {
    q: 'Is this only for sprint coaches?',
    a: 'No. It covers sprinting, hurdles, relays, endurance, race walking, all major jumps, all major throws and complete coaching-management systems.',
  },
  {
    q: 'What if it isn’t right for me?',
    a: 'The purchase includes a 7-day guarantee according to the stated conditions.',
  },
]
